import { Component, OnInit, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, of, switchMap, take } from 'rxjs';
import { common_urls } from 'src/environments/environment';
import { LoaderComponent } from '../loader/loader.component';
import { LoaderService } from 'src/app/service/loader.service';

@Component({
  selector: 'app-logout-page',
  standalone: true,
  imports: [LoaderComponent],
  templateUrl: './logout-page.component.html'
})
export class LogoutPageComponent implements OnInit {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly loaderService = inject(LoaderService);

  ngOnInit(): void {
    this.loaderService.show({ loaderType: 'SPINNER'});
    this.logoutAndRedirect();
  }

  private logoutAndRedirect(): void {
    this.oidcSecurityService.isAuthenticated$.pipe(
      take(1),
      switchMap(({ isAuthenticated }) => {
        if (!isAuthenticated) {
          return of(null);
        }

        return this.oidcSecurityService.logoff().pipe(
          catchError(() => of(null))
        );
      })
    ).subscribe({
      next: () => this.clearSessionAndRedirect(),
      error: () => this.clearSessionAndRedirect()
    });
  }

  private clearSessionAndRedirect(): void {
    sessionStorage.clear();
    localStorage.clear();
    window.open(`${common_urls.cwsBaseUrl}/Logout_page?cws=1&angredir=1`, '_self');
  }
}
